import React from "react";
import { createUseStyles } from "react-jss";
import { Prompt } from "../../Prompt";
import { Tooltip } from "../../Tooltip";
import { v4 as uuidv4 } from "uuid";
import { isArrayDefined } from "../../utils/isDefined";
import { useTranslation } from "../../hooks/useTranslation";
export const InlineFeedback = (props) => {
    const t = useTranslation();
    const classes = useInlineFeedbackClasses();
    const { message, shortMessage, type } = props;
    if (message) {
        return (React.createElement(Tooltip, { tooltipId: uuidv4(), content: message, iconShown: false },
            React.createElement(Prompt, { type: type ?? "warning", message: shortMessage ?? t("Issue"), className: classes.prompt })));
    }
    return (React.createElement(Prompt, { type: type ?? "warning", message: shortMessage ?? t("Issue"), className: classes.prompt }));
};
export const useInlineFeedbackClasses = () => {
    const useStyles = createUseStyles({
        prompt: {
            marginLeft: 4,
        },
    });
    return useStyles();
};
export function getInlineFeedback(feedback, rowKey, item, column) {
    if (column &&
        feedback &&
        isArrayDefined(feedback) &&
        rowKey &&
        typeof rowKey === "string") {
        const rowFeedback = feedback.filter((feedbackItem) => item?.id === feedbackItem.dataKey &&
            feedbackItem.columnKey === column?.key)[0];
        return rowFeedback;
    }
    return undefined;
}
export function drawersToOpenIfFeedback(feedback, rowKey, data) {
    let listOfIds = [];
    if (feedback && isArrayDefined(feedback) && data && isArrayDefined(data)) {
        feedback?.forEach((item) => {
            data?.forEach((row) => {
                if (rowKey && row[rowKey] === item.dataKey)
                    listOfIds.push(item.dataKey);
            });
        });
    }
    return listOfIds;
}
